import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTumblrComponent } from './simple-icons-tumblr.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTumblrComponent ],
    exports:      [ SimpleIconsTumblrComponent ],
    bootstrap:    []
})
export class SimpleIconsTumblrModule {}
